import { render, staticRenderFns } from "./FooterSegment.vue?vue&type=template&id=8281852e&"
import script from "./FooterSegment.vue?vue&type=script&lang=js&"
export * from "./FooterSegment.vue?vue&type=script&lang=js&"
import style0 from "./FooterSegment.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports